<template>
  <div class="home-page">
    <section class="hero">
      <img src="../assets/fotos/liquid.jpg" :alt="t('home.heroImageAlt')" class="hero-image" />
      <div class="hero-overlay"></div>
      <div class="hero-content section-wrap">
        <p class="hero-kicker">{{ t("home.kicker") }}</p>
        <h1>{{ t("home.title") }}</h1>
        <p>
          {{ t("home.lead") }}
        </p>
        <div class="hero-actions">
          <router-link :to="{ name: 'Portfolio' }" class="btn btn--primary">{{
            t("home.explorePortfolio")
          }}</router-link>
          <router-link :to="{ name: 'About' }" class="btn btn--ghost">{{
            t("home.startProject")
          }}</router-link>
        </div>
      </div>
    </section>

    <section class="stats section-wrap">
      <article>
        <h2>{{ t("home.statsYearsTitle") }}</h2>
        <p>{{ t("home.statsYearsBody") }}</p>
      </article>
      <article>
        <h2>{{ t("home.statsWeightTitle") }}</h2>
        <p>{{ t("home.statsWeightBody") }}</p>
      </article>
      <article>
        <h2>{{ t("home.statsFlowTitle") }}</h2>
        <p>{{ t("home.statsFlowBody") }}</p>
      </article>
    </section>

    <section class="story section-wrap">
      <article class="story-block">
        <img src="../assets/fotos/web/TZS03346.jpg" :alt="t('home.story1ImageAlt')" />
        <div>
          <p class="story-tag">{{ t("home.story1Tag") }}</p>
          <h2 class="section-title">{{ t("home.story1Title") }}</h2>
          <p class="section-lead">{{ t("home.story1Body") }}</p>
        </div>
      </article>

      <article class="story-block story-block--reverse">
        <img src="../assets/fotos/web/close_up_mold_2.jpg" :alt="t('home.story2ImageAlt')" />
        <div>
          <p class="story-tag">{{ t("home.story2Tag") }}</p>
          <h2 class="section-title">{{ t("home.story2Title") }}</h2>
          <p class="section-lead">{{ t("home.story2Body") }}</p>
        </div>
      </article>

      <article class="story-block">
        <img src="../assets/fotos/web/TZS03334.jpg" :alt="t('home.story3ImageAlt')" />
        <div>
          <p class="story-tag">{{ t("home.story3Tag") }}</p>
          <h2 class="section-title">{{ t("home.story3Title") }}</h2>
          <p class="section-lead">{{ t("home.story3Body") }}</p>
        </div>
      </article>
    </section>

    <section class="process section-wrap">
      <div class="process-head">
        <h2 class="section-title">{{ t("home.processTitle") }}</h2>
        <p class="section-lead">{{ t("home.processLead") }}</p>
      </div>
      <div class="process-grid">
        <article>
          <img src="../assets/fotos/web/TZS03230.jpg" :alt="t('home.process1ImageAlt')" />
          <h3>{{ t("home.process1Title") }}</h3>
          <p>{{ t("home.process1Body") }}</p>
        </article>
        <article>
          <img src="../assets/fotos/web/close_up_mold.jpg" :alt="t('home.process2ImageAlt')" />
          <h3>{{ t("home.process2Title") }}</h3>
          <p>{{ t("home.process2Body") }}</p>
        </article>
        <article>
          <img src="../assets/fotos/web/TZS03232.jpg" :alt="t('home.process3ImageAlt')" />
          <h3>{{ t("home.process3Title") }}</h3>
          <p>{{ t("home.process3Body") }}</p>
        </article>
      </div>
    </section>

    <section class="cta">
      <img src="../assets/fotos/web/outside_building.jpg" :alt="t('home.ctaImageAlt')" class="cta-image" />
      <div class="cta-overlay"></div>
      <div class="cta-content section-wrap">
        <h2>{{ t("home.ctaTitle") }}</h2>
        <p>{{ t("home.ctaBody") }}</p>
        <router-link :to="{ name: 'About' }" class="btn btn--primary">{{ t("home.ctaButton") }}</router-link>
      </div>
    </section>
  </div>
</template>

<script>
import { t } from "../i18n";

export default {
  name: "Home",
  methods: {
    t,
  },
};
</script>

<style lang="scss" scoped>
.home-page {
  padding-bottom: 4.5rem;
}

.hero {
  position: relative;
  min-height: min(84vh, 820px);
  display: grid;
  align-items: center;
  overflow: hidden;
}

.hero-image,
.cta-image {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.hero-overlay {
  position: absolute;
  inset: 0;
  background:
    linear-gradient(120deg, rgba(47, 15, 87, 0.88) 10%, rgba(15, 20, 28, 0.6) 52%, rgba(15, 20, 28, 0.45) 100%),
    radial-gradient(circle at 75% 20%, rgba(255, 255, 255, 0.15), transparent 35%);
}

.hero-content {
  position: relative;
  z-index: 2;
  color: #ffffff;
  padding: 6rem 0;
  animation: rise 560ms ease;
}

.hero-kicker {
  margin: 0;
  text-transform: uppercase;
  letter-spacing: 0.14em;
  font-weight: 650;
  font-size: 0.76rem;
  color: rgba(255, 255, 255, 0.82);
}

.hero h1 {
  margin: 0.8rem 0 0;
  max-width: 12ch;
  font-size: clamp(2.1rem, 6vw, 4.6rem);
  line-height: 0.98;
  text-transform: uppercase;
}

.hero p {
  margin: 1.25rem 0 0;
  max-width: 58ch;
  line-height: 1.7;
  color: rgba(255, 255, 255, 0.9);
}

.hero-actions {
  margin-top: 2rem;
  display: flex;
  flex-wrap: wrap;
  gap: 0.85rem;
}

.btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0.78rem 1.2rem;
  border-radius: 999px;
  text-decoration: none;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  font-size: 0.72rem;
  font-weight: 700;
  transition: transform var(--ease), box-shadow var(--ease), background var(--ease);
}

.btn:hover {
  transform: translateY(-2px);
}

.btn--primary {
  color: #ffffff;
  background: linear-gradient(135deg, #6b2ab6 0%, #2f0f57 100%);
  box-shadow: 0 16px 30px rgba(47, 15, 87, 0.32);
}

.btn--ghost {
  color: #ffffff;
  border: 1px solid rgba(255, 255, 255, 0.5);
  background: rgba(255, 255, 255, 0.08);
}

.stats {
  margin-top: -2rem;
  position: relative;
  z-index: 3;
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 1rem;
}

.stats article {
  background: rgba(255, 255, 255, 0.9);
  backdrop-filter: blur(4px);
  border: 1px solid rgba(91, 28, 159, 0.12);
  border-radius: 20px;
  padding: 1.4rem;
  box-shadow: 0 14px 35px rgba(15, 20, 28, 0.1);
}

.stats h2 {
  margin: 0;
  font-size: clamp(1.15rem, 2.8vw, 1.85rem);
  color: var(--brand-purple-deep);
}

.stats p {
  margin: 0.45rem 0 0;
  color: #4f586a;
}

.story {
  margin-top: 4.2rem;
  display: grid;
  gap: 2.6rem;
}

.story-block {
  display: grid;
  grid-template-columns: 1.1fr 1fr;
  gap: 1.9rem;
  align-items: center;
}

.story-block img {
  width: 100%;
  aspect-ratio: 16 / 11;
  object-fit: cover;
  border-radius: 24px;
  box-shadow: 0 16px 30px rgba(15, 20, 28, 0.15);
}

.story-tag {
  margin: 0;
  text-transform: uppercase;
  letter-spacing: 0.12em;
  font-size: 0.74rem;
  font-weight: 700;
  color: var(--brand-purple);
}

.story-block .section-title {
  margin-top: 0.4rem;
  margin-bottom: 0.75rem;
  font-size: clamp(1.5rem, 3.8vw, 2.8rem);
}

.story-block--reverse {
  grid-template-columns: 1fr 1.1fr;
}

.story-block--reverse img {
  order: 2;
}

.process {
  margin-top: 4.5rem;
}

.process-head {
  display: grid;
  gap: 0.8rem;
  margin-bottom: 1.5rem;
}

.process-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 1.2rem;
}

.process-grid article {
  background: #ffffff;
  border: 1px solid rgba(91, 28, 159, 0.12);
  border-radius: 22px;
  overflow: hidden;
  box-shadow: 0 14px 30px rgba(15, 20, 28, 0.08);
  animation: rise 560ms ease both;
}

.process-grid article:nth-child(2) {
  animation-delay: 80ms;
}

.process-grid article:nth-child(3) {
  animation-delay: 140ms;
}

.process-grid img {
  width: 100%;
  aspect-ratio: 16 / 10;
  object-fit: cover;
}

.process-grid h3 {
  margin: 1rem 1.1rem 0;
  font-size: 1rem;
  color: #1e2532;
}

.process-grid p {
  margin: 0.6rem 1.1rem 1.2rem;
  color: #535e71;
  line-height: 1.65;
}

.cta {
  margin-top: 4.6rem;
  min-height: 360px;
  position: relative;
  display: grid;
  align-items: center;
  overflow: hidden;
}

.cta-overlay {
  position: absolute;
  inset: 0;
  background: linear-gradient(105deg, rgba(15, 20, 28, 0.88) 22%, rgba(47, 15, 87, 0.72) 100%);
}

.cta-content {
  position: relative;
  z-index: 2;
  color: #ffffff;
  padding: 3.5rem 0;
}

.cta h2 {
  margin: 0;
  font-size: clamp(1.75rem, 4vw, 3rem);
  text-transform: uppercase;
  max-width: 20ch;
}

.cta p {
  max-width: 58ch;
  color: rgba(255, 255, 255, 0.88);
  line-height: 1.7;
}

@keyframes rise {
  from {
    opacity: 0;
    transform: translateY(12px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@media (max-width: 980px) {
  .stats,
  .process-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .story-block,
  .story-block--reverse {
    grid-template-columns: 1fr;
  }

  .story-block--reverse img {
    order: 0;
  }
}

@media (max-width: 680px) {
  .hero {
    min-height: 74vh;
  }

  .hero-content {
    padding: 4.5rem 0;
  }

  .stats,
  .process-grid {
    grid-template-columns: 1fr;
  }

  .cta {
    min-height: 310px;
  }
}
</style>
